var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50739 14.9001L6.2145 15.6072L6.9216 14.9001L11.7216 10.1001L12.4287 9.39296L11.0145 7.97875L10.3074 8.68586L7.2145 11.7788L7.2145 1.39296V0.392963H5.2145V1.39296L5.2145 11.7788L2.1216 8.68586L1.4145 7.97875L0.000284195 9.39296L0.707391 10.1001L5.50739 14.9001Z",
    fill: "#102A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIot);
export default __webpack_public_path__ + "static/media/arrow_down_iot.296510bb269907167af2901938a5b1dc.svg";
export { ForwardRef as ReactComponent };